import React, { useState } from "react";
import { FaTimes, FaCheck, FaTimesCircle } from "react-icons/fa";

export default function QuizModal({ course, onClose, onComplete }) {
  const [answers, setAnswers] = useState({});
  const [score, setScore] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const questions = course.test_questions || [];

  const handleAnswerChange = (qIndex, optionIndex) => {
    setAnswers({ ...answers, [qIndex]: optionIndex });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let correct = 0;
    questions.forEach((q, index) => {
      if (answers[index] === q.correct) correct++;
    });
    const percentage = (correct / questions.length) * 100;
    setScore(percentage);
    setSubmitted(true);
    onComplete(percentage, course.id);
  };

  if (submitted) {
    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="modal-header">
            <h3>Hasil Tes: {course.title}</h3>
            <button onClick={onClose} className="close-btn">
              <FaTimes />
            </button>
          </div>
          <div className="quiz-result">
            <h4>Skor Anda: {Math.round(score)}%</h4>
            {score >= 80 ? (
              <div className="pass">
                <FaCheck size={50} color="green" />
                <p>Selamat! Anda lulus. Materi PDF kini tersedia untuk diunduh.</p>
              </div>
            ) : (
              <div className="fail">
                <FaTimesCircle size={50} color="red" />
                <p>Belum lulus (minimal 80%). Coba lagi setelah menonton video.</p>
              </div>
            )}
            <button onClick={onClose}>Tutup</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Tes: {course.title}</h3>
          <button onClick={onClose} className="close-btn">
            <FaTimes />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="quiz-form">
          {questions.map((q, qIndex) => (
            <div key={qIndex} className="question">
              <h4>{q.question}</h4>
              {q.options.map((option, oIndex) => (
                <label key={oIndex} className="option">
                  <input
                    type="radio"
                    name={`q${qIndex}`}
                    value={oIndex}
                    checked={answers[qIndex] === oIndex}
                    onChange={() => handleAnswerChange(qIndex, oIndex)}
                    required
                  />
                  {option}
                </label>
              ))}
            </div>
          ))}
          <button type="submit">Submit Tes</button>
        </form>
      </div>
    </div>
  );
}
